<template>
  <v-dialog
    v-model="enable"
    persistent
    width="800"
    >
    <v-card
      v-if="teacher"
      class="main--text">
      <v-container
        fluid>
        <div
          class="text-end">
            <v-icon
            @click="$emit('close-button-click')">mdi-close</v-icon>
        </div>
        <v-row
          dense>
          <v-col
            cols=12
            md=3
            sm=3>
            <v-container
              fluid>
              <v-row
                justify=center
                justify-sm=end
                justify-md=end
                >
                <v-col
                  cols=auto>
                <v-avatar size="120px">
                  <img :src="teacher.iconUrl" alt="">
                </v-avatar>
                </v-col>
              </v-row>
              <div  style="text-align:right">
                <h2 :class="leftItemsStyle">{{ teacher.fullName() }}</h2>
                <p :class="leftItemsStyle">
                  {{ teacher.flatFullName() }}<br>
                  {{ teacher.genderInJapanese() }}
                </p>
              </div>
            </v-container>
          </v-col>
          <v-col
            cols=12
            md=9
            sm=9>
            <v-container
              fluid>
              <h5>自己PR</h5>
              <p class="line--feed">{{ teacher.selfIntroduction }}</p>
              <br>
              <h5>学歴</h5>
              <p>{{ teacher.universityInfo() }}</p>
              <h5>希望時給</h5>
              <p>{{teacher.expectedWage}}円</p>
              <h5>対応可能スケジュール</h5>
              <v-chip
                v-for="(schedule, index) in teacher.availableSchedulesToStrings()"
                :key="index"
                outlined>{{schedule}}</v-chip>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    enable: {
      type: Boolean,
      required: true
    },
    teacher: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      leftItemsStyle: "text-center text-sm-right text-md-right"
    }
  },
  methods: {
    request() {
      this.$emit("request-button-click", this.teacher)
      this.pushed = true
    }
  }
}
</script>
